import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ann/web-components';
import { WIDGET_GRID_COPY } from '../../constants';
import { Container, Message } from './WidgetErrorState.styled';

const WidgetErrorState = ({ message, onRetry }) => {
  return (
    <Container>
      <Message>{message}</Message>
      <Button type="secondary" size="small" onClick={onRetry}>
        {WIDGET_GRID_COPY.actions.retry}
      </Button>
    </Container>
  );
};

WidgetErrorState.propTypes = {
  message: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
};

WidgetErrorState.defaultProps = {
  message: WIDGET_GRID_COPY.errors.generic,
};

export default WidgetErrorState;
